<template>
    <div>
        <li class="nav-item d-md-none">
            <a class="nav-link" @click.prevent="shwoModal">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14"
                        viewBox="0 0 24 24" fill="none" stroke="white"
                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="feather feather-menu ficon">
                    <line x1="3" y1="12" x2="21" y2="12"></line>
                    <line x1="3" y1="6" x2="21" y2="6"></line>
                    <line x1="3" y1="18" x2="21" y2="18"></line>
                </svg>
            </a>
        </li>
        <div class="modal left fade" id="menuModal" tabindex="-1" role="dialog" aria-labelledby="menuModalLabel">
            <div class="modal-dialog" role="document">
                <div class="modal-content">

                    <div class="modal-header">
                        <div class="font_13">
                            Souscrivez à vos poduits d’assurance de chez vous en toute simplicité
                        </div>
                        <div v-if="auth === ''" class="burgger__button">
                            <a class="btn btn-secondary" :href="$routing('auth/login')"><span>Se connecter</span></a>
                            <a class="btn btn-light" :href="$routing('auth/register')"><span>Créer un compte</span></a>
                        </div>
                    </div>

                    <div class="modal-body">
                        <nav>
                            <a class="link_p" href="/">Accueil</a>
                            <hr>
                            <div class="prod__sec">
                                <div class="prod__title">Produits</div>
                                <a :href="$routing('assurance-automobile')" class="mb-1">Assurance Auto</a><br>
                                <a :href="$routing('assurance-habitation')" class="mb-1">Assurance multirisque habitation “APEFA”</a><br>
                                <a :href="$routing('assurance-voyage')">Assurance Voyage</a><br>
                            </div>
                            <hr>
                            <a :href="$routing('contact')" class="link_p">Contact</a>
                            <hr>
                            <a class="link_p" :href="$routing('suggestion')">Suggestions</a>
                        </nav>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
var $this;
export default {
    methods:{
        shwoModal(){
            this.$document('#menuModal').modal('show')
        }
    },
    props: ['auth'],

    created(){
        $this = this;
    },
    mounted(){
        setTimeout(() => {
            $this.$document('body').click(function (event) {
                if(!$this.$document(event.target).closest('#menuModal').length && !$this.$document(event.target).is('#menuModal')) {
                    $this.$document("#menuModal").modal('hide');
                }
            });
        }, 500)
    }
}
</script>

<style lang="scss" scoped>
	.modal.left .modal-dialog,
	.modal.right .modal-dialog {
        z-index: 10000;
		position: fixed;
		margin: auto;
		width: 320px;
		height: 100%;
        top: 0;
		-webkit-transform: translate3d(0%, 0, 0);
		    -ms-transform: translate3d(0%, 0, 0);
		     -o-transform: translate3d(0%, 0, 0);
		        transform: translate3d(0%, 0, 0);
	}

	.modal.left .modal-content,
	.modal.right .modal-content {
		height: 100%;
		overflow-y: auto;
	}

	.modal.left .modal-body,
	.modal.right .modal-body {

	}

/*Left*/
	.modal.left.fade .modal-dialog{
		left: -320px;
		-webkit-transition: opacity 0.3s linear, left 0.3s ease-out;
		   -moz-transition: opacity 0.3s linear, left 0.3s ease-out;
		     -o-transition: opacity 0.3s linear, left 0.3s ease-out;
		        transition: opacity 0.3s linear, left 0.3s ease-out;
	}

	.modal.left.fade.show .modal-dialog{
		left: 0;
	}

/*Right*/
	.modal.right.fade .modal-dialog {
		right: -320px;
		-webkit-transition: opacity 0.3s linear, right 0.3s ease-out;
		   -moz-transition: opacity 0.3s linear, right 0.3s ease-out;
		     -o-transition: opacity 0.3s linear, right 0.3s ease-out;
		        transition: opacity 0.3s linear, right 0.3s ease-out;
	}

	.modal.right.fade.show .modal-dialog {
		right: 0;
	}

	.modal-content {

	}

	.modal-header {
		border-bottom-color: #001E5F;
		background-color: #001E5F;
        color: #FFFFFF;
        padding: 20px;
        display: block;
        height: 120px;
        .font_13{ font-size: 13px; }
        .burgger__button{
            display: grid;
            grid-template-columns: 1fr 1fr;
            grid-gap: 10px;
            margin-top: 10px;
            a {
                span{
                    font-size: 13px !important;
                }
            }
        }
	}
    .prod__title{
        color: #B9B9C3 !important;
    }
    .prod__sec{
        a{
            margin-left: 10px !important;
            color: #5E5873;
        }
    }
    .link_p{
        color: #5E5873;
    }
</style>
